import Pie from './index.vue'
import { pieCodes } from './config'

export function installPie() {
  return Object.values(pieCodes).map(code => {
    const name = `KyeReport${code}`
    return {
      extends: Pie,
      name,
      data() {
        return {
          code,
        }
      },
    }
  })
}



// WEBPACK FOOTER //
// ./src/public/components/kye-report-form/echarts/pie/install.js